<script setup lang="ts">
import { faRefresh } from '@fortawesome/pro-regular-svg-icons/faRefresh';
import { HotelApiApiHotelCommentCaptchaGet } from '@clients/HotelApi';

const src = ref('');
const input = defineModel<string>('input', { default: '' });
const text = defineModel<string>('text', { default: '' });
const token = defineModel<string>('token', { default: '' });
const loading = ref(false);
async function loadCaptcha(): Promise<void> {
    loading.value = true;
    try {
        const { data } = await HotelApiApiHotelCommentCaptchaGet({
            withCredentials: true,
        });
        src.value = data.dntCaptchaImgUrl ?? '';
        text.value = data.dntCaptchaTextValue ?? '';
        token.value = data.dntCaptchaTokenValue ?? '';
    } catch (e) {
        reportException(e);
    } finally {
        loading.value = false;
    }
}
onMounted(() => loadCaptcha());
</script>
<template>
    <div class="captcha-input-container">
        <mr-input
            v-model="input"
            required
            label="متن تصویر روبرو"
            hide-description
        />
        <img :src alt="captcha" />
        <mr-button :icon-button="faRefresh" :loading @click="loadCaptcha" />
    </div>
</template>
<style scoped lang="scss">
.captcha-input-container {
    display: flex;
    gap: 16px;
    align-items: flex-end;
    img {
        width: auto;
        height: 48px;
    }
}
</style>
